import React from 'react';
import { Link } from 'react-router-dom';
import { TYPOGRAPHY, STYLES, SPACING } from '../../designSystem';

export default function PageHeader({
  title,
  subtitle,
  primaryAction,
  backLink,
  backText = '← Back',
}) {
  const backButtonStyle = {
    ...STYLES.buttonGhost,
    padding: `${SPACING.SM} ${SPACING.LG}`,
    display: 'inline-flex',
    alignItems: 'center',
    gap: SPACING.SM,
    fontSize: TYPOGRAPHY.BODY.fontSize,
  };

  return (
    <>
      {backLink && (
        <div style={{ maxWidth: '1400px', margin: '0 auto 16px' }}>
          <Link to={backLink} style={backButtonStyle}>
            {backText}
          </Link>
        </div>
      )}
      <div style={STYLES.pageHeader}>
        <div>
          <h1 style={STYLES.pageTitle}>{title}</h1>
          {subtitle && <p style={STYLES.pageSubtitle}>{subtitle}</p>}
        </div>
        {primaryAction && <div>{primaryAction}</div>}
      </div>
    </>
  );
}
